export default __webpack_public_path__ + "media/birds-19624.e2c701de.mp3";